import "@/config/bootstrap";
import "./global.css";

import { REACT_APP__BASE_PATH } from "@smp/utils";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";

import { useCookiePolicyInit } from "@/hooks/use_cookie_policy_init";
import { useGscInit } from "@/hooks/use_gsc_init";

import createRoutes from "./create_routes";
import reportWebVitals from "./reportWebVitals";

registerSW({ immediate: true });

export const queryClientInitial = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 5,
    },
  },
});

const $container = document.getElementById("smmplanner-front")!;
const routes = createRoutes(queryClientInitial);
const router = createBrowserRouter(routes, {
  basename: `${REACT_APP__BASE_PATH}/`.replace(/\/\//g, "/"),
});

const Root = () => {
  useGscInit();
  useCookiePolicyInit();

  return (
    <>
      <QueryClientProvider client={queryClientInitial}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </>
  );
};

$container.innerHTML = "";
document
  .querySelectorAll("style[data-emotion='css-global-ssg']")
  .forEach((el) => el.remove());

ReactDOM.createRoot(document.getElementById("smmplanner-front")!).render(
  <Root />,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
